import { ApiService } from "./ApiService"

export class WhatsAppTemplateService {

    static uri = '/wa/template';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }

    static update({ id, data }) {
        return ApiService.post(`${this.uri}/update/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }

    static delete({ id}) {
        return ApiService.delete(`${this.uri}/delete/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            }
        });
    }
    
    
}